import React from "react";

interface InputBoxProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

const InputBox: React.FC<InputBoxProps> = ({
  value,
  onChange,
  placeholder = "Insert your answer",
  disabled = false,
}) => {
  const isDisabled = disabled;

  return (
    <input
      className={isDisabled ? "input-box-container-disable" : "input-box-container"}
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={isDisabled}
    />
  );
};

export default InputBox;
